import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { ModalModule } from '@epicuro-next/ataraxia/modal';
import { RadioGroupModule } from '@epicuro-next/ataraxia/radio-group';
import { BasketUploadStateModule } from '@epicuro-next/state/basket-upload-state';
import { LetDirective, PushPipe } from '@ngrx/component';

import { UploadBasketModalComponent } from './components/upload-basket-modal/upload-basket-modal.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    BasketUploadStateModule,
    ModalModule,
    RadioGroupModule,
    LetDirective,
    PushPipe,
    IconsModule,
  ],
  declarations: [UploadBasketModalComponent],
  exports: [UploadBasketModalComponent],
})
export class FeaturesUploadBasketModule {}
